import { Flex } from 'antd'
import { Icon } from 'shared/iconpack'

import { Image } from 'shared/ui'
import { Button } from 'shared/ui/button'

import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './SupportItem.module.scss'

interface SupportItemProps {
  link: string
  label: string
  logo: string
}

export function SupportItem({ label, link, logo }: SupportItemProps) {
  return (
    <>
      <Button href={link} variant="additional" className={styles.supportItem}>
        <Flex gap={8} justify="space-between" align="center">
          <div className={styles.iconWrapper}>
            <Image
              width={28}
              height={28}
              src={logo}
              alt=""
              className={styles.logo}
            />
          </div>
          <span className={styles.label}>{label}</span>
        </Flex>
        <Icon
          name="chevronRight"
          size={20}
          color={globalStyles['--icon-secondary']}
        />
      </Button>
    </>
  )
}
